import {paperclipSvg as Icon__small__paperclipSvg} from '../Icon__small/Icon__small--paperclip.js';

export var paperclip = {
  name: 'paperclip',
  category: 'icon',
  colorable: true,
  svg: Icon__small__paperclipSvg,
};
